import * as React from 'react';
import { Link } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, ImageWithCaption } from '@emorg-prd/standard-react';
import { Grid, Button, Alert } from '../../common';
import NewDNDRInfoImage from '../../../images/newDNDRInfoImage.png';
import './NewDNDRInfoModal.css';

interface NewDNDRInfoModalProps {
	visible: boolean;
	onClose: () => any;
}

interface NewDNDRInfoModalState {
}

export default class NewDNDRInfoModal extends React.Component<
	NewDNDRInfoModalProps,
	NewDNDRInfoModalState> {


	componentDidMount() {
		const overlay = document.querySelector('.DNDRInfoModal .em-c-modal__overlay');
		if (overlay) {
			const handler = (e: Event) => {
				e.stopPropagation(); // blocks closing by overlay
			};
			overlay.addEventListener('click', handler, true);
			// refs for cleanup
			(this as any)._overlay = overlay;
			(this as any)._overlayHandler = handler;
		}
	}

	componentWillUnmount() {
		const overlay = (this as any)._overlay as HTMLElement | undefined;
		const handler = (this as any)._overlayHandler as ((e: Event) => void) | undefined;
		overlay?.removeEventListener('click', handler!, true);
	}

	render() {
		return (<>
			<button
				type="button"
				className="em-js-modal-trigger"
				style={{ display: 'none' }}
				aria-hidden="true"
			>
				<span className="em-c-primary-nav__link" />
			</button>

			<Modal
				show={this.props.visible}
				optionalClass='DNDRInfoModal'
			>
				<ModalHeader
					onClick={this.props.onClose}
					title="New DPI (Deep Packet Inspection) Exception Request"
				/>
				<ModalBody>
					<Alert
						variant="warning"
						className="no-alert-actions"
						body='For DPI (Deep Packet Inspection) Exception Requests please go to
							the subscriptions page and follow the instructions
							in the image below.'
						onClose={() => []}
					/>
					<ImageWithCaption
						src={NewDNDRInfoImage}
						caption=""
						alt="NewDNDRInfoImage"
					/>
				</ModalBody>				
				<ModalFooter>
					<Grid variant="2up">
						<Grid.Item>
							<Button
								variant="secondary"
								onClick={this.props.onClose}>
								Cancel
							</Button>
						</Grid.Item>
						<Grid.Item>
							<Link to="/subscriptions" className="redirect-button">
								<Button
									variant="primary"
									optionalClass="redirect-button"
								>
									Go to Subscriptions
								</Button>
							</Link>
						</Grid.Item>
					</Grid>
				</ModalFooter>
			</Modal>
		</>);
	}
}
